export enum StyleLimits {
  OK = 25,
  GOOD = 50,
  GREAT = 75,
}

export enum RecommendedTherapistProfileBioVariant {
  CONTROL = 'control',
  EXPANDABLE = 'expandable',
  ALL_CONTENT = 'all-content',
}
